(() => {
  const root = document.querySelector('[data-wp-home]');
  if (!root) return;

  const menu = root.querySelector('[data-wp-menu]');
  const overlay = root.querySelector('[data-wp-overlay]');
  const openMenuButton = root.querySelector('[data-wp-menu-open]');
  const closeMenuButton = root.querySelector('[data-wp-menu-close]');

  const setMenu = (open) => {
    if (!menu || !overlay) return;
    menu.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    openMenuButton?.setAttribute('aria-expanded', String(open));
    document.documentElement.style.overflow = open ? 'hidden' : '';
  };

  openMenuButton?.addEventListener('click', () => setMenu(true));
  closeMenuButton?.addEventListener('click', () => setMenu(false));
  overlay?.addEventListener('click', () => setMenu(false));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  const newsletterPopup = root.querySelector('[data-wp-newsletter-popup]');
  const newsletterOpeners = [...root.querySelectorAll('[data-wp-newsletter-open]')];
  const newsletterClosers = [...root.querySelectorAll('[data-wp-newsletter-close]')];
  const newsletterEmail = root.querySelector('[data-wp-newsletter-email]');
  const newsletterState = root.querySelector('[data-wp-newsletter-state]');
  const newsletterStorageKey = 'wyciszpsiaka-newsletter-dismissed';
  let newsletterPreviousFocus = null;

  const newsletterWasDismissed = () => {
    try {
      return window.sessionStorage.getItem(newsletterStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  };

  const rememberNewsletterDismissal = () => {
    try {
      window.sessionStorage.setItem(newsletterStorageKey, 'true');
    } catch (error) {
      // Popup nadal działa, nawet gdy przeglądarka blokuje sessionStorage.
    }
  };

  const setNewsletter = (open, rememberDismissal = false) => {
    if (!newsletterPopup) return;

    if (open) {
      setMenu(false);
      newsletterPreviousFocus = document.activeElement;
      newsletterPopup.classList.add('is-open');
      newsletterPopup.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => {
        (newsletterEmail || newsletterPopup.querySelector('.wp-newsletter-popup__close'))?.focus();
      }, 80);
      return;
    }

    newsletterPopup.classList.remove('is-open');
    newsletterPopup.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';

    if (rememberDismissal) rememberNewsletterDismissal();
    newsletterPreviousFocus?.focus?.();
  };

  newsletterOpeners.forEach((opener) => {
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      setNewsletter(true);
    });
  });

  newsletterClosers.forEach((closer) => {
    closer.addEventListener('click', () => setNewsletter(false, true));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    if (newsletterPopup?.classList.contains('is-open')) {
      setNewsletter(false, true);
      return;
    }

    if (menu?.classList.contains('is-open')) setMenu(false);
  });

  const newsletterHasResult =
    newsletterState?.dataset.success === 'true' ||
    newsletterState?.dataset.error === 'true';

  if (newsletterHasResult) {
    window.setTimeout(() => setNewsletter(true), 150);
  } else if (!newsletterWasDismissed()) {
    window.setTimeout(() => setNewsletter(true), 2800);
  }

  const booksTrack = root.querySelector('[data-wp-books]');
  const books = [...root.querySelectorAll('[data-wp-book]')];
  const bookDots = [...root.querySelectorAll('[data-wp-book-dot]')];
  let booksFrame;

  const setActiveBook = (index) => {
    bookDots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
    });
  };

  const updateActiveBook = () => {
    if (!booksTrack || !books.length) return;

    const trackLeft = booksTrack.getBoundingClientRect().left;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    books.forEach((book, index) => {
      const distance = Math.abs(
        book.getBoundingClientRect().left - trackLeft
      );

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    setActiveBook(closestIndex);
  };

  booksTrack?.addEventListener(
    'scroll',
    () => {
      window.cancelAnimationFrame(booksFrame);
      booksFrame = window.requestAnimationFrame(updateActiveBook);
    },
    { passive: true }
  );

  bookDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      if (!booksTrack || !books[index]) return;

      booksTrack.scrollTo({
        left: books[index].offsetLeft - booksTrack.offsetLeft,
        behavior: 'smooth'
      });

      setActiveBook(index);
    });
  });

  root.querySelectorAll('[data-wp-package-url]').forEach((card) => {
    const openPackage = () => {
      const packageUrl = card.dataset.wpPackageUrl;
      if (packageUrl) window.location.href = packageUrl;
    };

    card.addEventListener('click', (event) => {
      if (event.target.closest('form, button, a, input, select, textarea')) return;
      openPackage();
    });

    card.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target.closest('form, button, a, input, select, textarea')) return;
      event.preventDefault();
      openPackage();
    });
  });

  const reviews = [...root.querySelectorAll('[data-wp-review]')];
  const reviewControls = root.querySelector('.wp-review-controls');
  if (reviewControls && reviews.length <= 1) reviewControls.hidden = true;

  let activeReview = 0;

  const showReview = (index) => {
    if (!reviews.length) return;
    activeReview = (index + reviews.length) % reviews.length;
    reviews.forEach((review, i) => review.classList.toggle('is-active', i === activeReview));
  };

  root.querySelector('[data-wp-review-prev]')?.addEventListener('click', () => showReview(activeReview - 1));
  root.querySelector('[data-wp-review-next]')?.addEventListener('click', () => showReview(activeReview + 1));

  const toast = root.querySelector('[data-wp-toast]');
  let toastTimer;

  const showToast = (message, isError = false) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.toggle('is-error', isError);
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3600);
  };

  const addUrl = root.dataset.cartAddUrl;
  const cartUrl = root.dataset.cartUrl;

  root.querySelectorAll('[data-wp-add-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!button || button.disabled || !addUrl) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'DODAJĘ…';

      try {
        const response = await fetch(`${addUrl}.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });

        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Nie udało się dodać produktu.');

        showToast('Pakiet dodany do koszyka. Przenoszę do koszyka…');
        window.setTimeout(() => {
          window.location.href = cartUrl || '/cart';
        }, 450);
      } catch (error) {
        showToast(error.message || 'Wystąpił błąd. Spróbuj ponownie.', true);
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  });
})();
